export interface PortfolioProject {
  id?: string;
  title: string;
  description: string;
  tags: string[];
  imageUrl: string;
  liveUrl?: string;
  githubUrl?: string;
  status?: string;
  featured?: boolean;
  order?: number;
}

export async function getProjects(): Promise<PortfolioProject[]> {
  try {
    const response = await fetch("/api/projects");
    if (!response.ok) {
      throw new Error("Projects API failed");
    }

    const data = (await response.json()) as { projects?: PortfolioProject[] };
    return data.projects || [];
  } catch {
    return [];
  }
}

export async function saveProject(
  project: PortfolioProject,
  adminKey: string,
): Promise<void> {
  const method = project.id ? "PUT" : "POST";
  const response = await fetch("/api/projects", {
    method,
    headers: {
      "Content-Type": "application/json",
      "x-admin-key": adminKey,
    },
    body: JSON.stringify(project),
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(data?.message || "Project could not be saved.");
  }
}

export async function deleteProject(id: string, adminKey: string): Promise<void> {
  const response = await fetch(`/api/projects?id=${encodeURIComponent(id)}`, {
    method: "DELETE",
    headers: {
      "x-admin-key": adminKey,
    },
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(data?.message || "Project could not be deleted.");
  }
}
